import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import ConfigContext from "../context/ConfigContext";
import { useApiRequest } from "../components/useApiRequest";
import { Header } from "../components/Header";
import { Report } from "../components/Report";
import { Menu } from "../components/Menu";
import { ReportNewTab } from "../components/ReportNewTab";
import "../App.css";
import loader from "../content/images/search_loading.gif";

export const DefaultView = () => {
	const configData = useContext(ConfigContext);
	const [searchParams, setSearchParams] = useSearchParams();
	const newTab = searchParams.get("clientNumber") && searchParams.get("payPeriod") && searchParams.get("isPending");
	if (!newTab) {
		Menu(configData.REACT_APP_MENU_URL, "AppNavigation");
	}
	const { isAuthenticated, user } = useContext(AuthContext);
	const [url, setUrl] = useState(null);
	const [viewer, setViewer] = useState(null);
	const [clientNumber, setClientNumber] = useState(user.isImpersonating ? user.impersonatedUserClientNumber : user.loggedInUserClientNumber);
	const [payPeriod, setPayPeriod] = useState(null);
	const [spread, setSpread] = useState(null);
	const [loading, setLoading] = useState(true);
	const { data, error, isLoaded } = useApiRequest(url);

	if (newTab) {
		return (
			<ReportNewTab></ReportNewTab>
		);
	}

	useEffect(() => {
		setLoading(true);
		setUrl(configData.REACT_APP_VIEW_AS_URL + `/${clientNumber}`);
	}, [clientNumber, url]);

	useEffect(() => {
		setViewer(data);
		setLoading(false);
	}, [data]);

	if (error !== null) {
		console.log("error fetching viewer info: ", error.message);
		return <div>Error: Unable to retrieve client data</div>;
	}

	if (!isLoaded) {
		return (
			<div style={{ padding: "0.3rem", textAlign: "center" }}>
				<img src={loader} alt="Loading " />
			</div>
		);
	}
	if (isLoaded) {
		return (
			<div className="App">
				<div id="content">
					<div className="main-content">
						<div style={{ padding: "1% 2% 2%" }}>
							{ (viewer && spread && clientNumber) &&
								<Header viewer={viewer} clientNumber={clientNumber} setClientNumber={setClientNumber} setPayPeriod={setPayPeriod} loading={loading}></Header>
							}
							{ <Report payPeriod={payPeriod} clientNumber={clientNumber} spread={spread} setSpread={setSpread}></Report> }
						</div>
					</div>
				</div>
			</div>
		);
	}
};